import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";
import "firebase/database";
import 'firebase/analytics';
import store from "../../Redux_Store";
// let server =
// "http://localhost:5001/possibilities-parenting/us-central1/serverResponse";
const config = {
  apiKey: "AIzaSyBSO_Oiqjs3Nm67f3ICjB9lhwmYQjl1-_U",
  authDomain: "acp-illumine-2021.firebaseapp.com",
  databaseURL: "https://acp-illumine-2021-default-rtdb.firebaseio.com",
  projectId: "acp-illumine-2021",
  storageBucket: "acp-illumine-2021.firebasestorage.app",
  messagingSenderId: "597598927275",
  appId: "1:597598927275:web:3fdbb9ff37a9ee82993aee"
};

firebase.initializeApp(config);
// firebase.analytics();

const analytics = firebase.analytics();

firebase.auth().onIdTokenChanged(user => {
  if (user) {
    analytics.setUserId(user.uid);
    analytics.setUserProperties({id: user.uid});
  }
});

export const loginAttempt = ({ email, password, successCallBack, failureCallback }) => {
  return dispatch => {
    dispatch({ type: "LOGIN_ATTEMPT", payload: true });
    if (password === "" && email !== "") {
      let errMsg = {};
      errMsg.message = "Please enter a valid password";
      loginAttempFail(dispatch, errMsg, failureCallback);
    } else {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(user => {
          loginAttempSuccess(dispatch, user, successCallBack);
        })
        .catch(err => {
          // Keep the message on screen until the next attempt; it used to vanish after 3s.
          let errMsg = getErrorMsg(err);
          loginAttempFail(dispatch, errMsg, failureCallback);
        });
    }
  };
};

firebase
  .auth()
  .onAuthStateChanged(function (user) {
    if (user) {
      markSignedInSinceUpdate();
      let uid = user.uid;
      firebase
        .database()
        .ref(`/users/${uid}`)
        .on('value', userSnapshot => {
          let userData = userSnapshot.val();
          store.dispatch({ type: "SYNC_LOCAL_FROM_GLOBAL", payload: userData });
        });
    } else {
      // Firebase has no session (expired, signed out elsewhere, or saved by an
      // older version/project), but the persisted Redux state may still say
      // "logged in". Clear it so the user is sent to the login screen instead
      // of seeing cached data that the database rules will refuse to refresh.
      // Wait for redux-persist to rehydrate first, or the stale flag would be
      // restored after we clear it.
      whenRehydrated(() => {
        if (!firebase.auth().currentUser && store.getState().auth.isLoggedIn) {
          store.dispatch({ type: "LOGOUT_ATTEMPT" });
        }
      });
    }
  });

function whenRehydrated(callback) {
  const isRehydrated = () => {
    const persist = store.getState()._persist;
    return persist && persist.rehydrated;
  };
  if (isRehydrated()) {
    callback();
    return;
  }
  const unsubscribe = store.subscribe(() => {
    if (isRehydrated()) {
      unsubscribe();
      callback();
    }
  });
}

export const registerAttempt = ({
  email,
  password,
  firstName,
  phoneNumber,
  successCallBack,
  failureCallback
}) => {
  return dispatch => {
    dispatch({ type: "REGISTER_ATTEMPT", payload: true });
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .catch(err => {
        loginAttempFail(dispatch, err, failureCallback);
      })
      .then(user => {
        //Send a Verification mail to the user
        if (user) {
          firebase
            .auth()
            .currentUser
            .sendEmailVerification()
            .catch(error => { });

          let updates = {
            email,
            firstName,
            phoneNumber
          };
          firebase
            .database()
            .ref(`/users/${user.user.uid}/userAccount`)
            .update(updates)
            .catch(err => {
              console.log("user profile update failed")
            });

          loginAttempSuccess(dispatch, user, successCallBack);
        }
      });
  };
};

export const setErrMsg = el => {
  return dispatch => {
    dispatch({ type: "SET_LOGIN_ERROR_MSG", payload: el });
  };
};

export const resetPassword = email => {
  var auth = firebase.auth();
  var emailAddress = (email || "").trim();
  // After resetting, Firebase's page offers a "Continue" button back to our login page.
  var actionCodeSettings = { url: `${window.location.origin}/auth/login` };
  return dispatch => {
    if (emailAddress) {
      dispatch({ type: "PASSWORD_RESET_IN_PROGRESS", payload: true });
      const linkSent = () => dispatch({ type: "RESET_PASSWORD_LINK_SENT", payload: true });
      auth
        .sendPasswordResetEmail(emailAddress, actionCodeSettings)
        .catch(function (error) {
          // If this domain isn't in Firebase Auth's authorized domains yet,
          // send the email without the continue link rather than failing.
          if (error && (error.code === "auth/unauthorized-continue-uri" || error.code === "auth/invalid-continue-uri")) {
            return auth.sendPasswordResetEmail(emailAddress);
          }
          throw error;
        })
        .then(linkSent)
        .catch(function (error) {
          // Tell the person there's no account rather than pretending a link was sent.
          // Firebase only reports this when email-enumeration protection is off;
          // with it on, unknown emails still come back as success.
          if (error && error.code === "auth/user-not-found") {
            setErrorMsgInForgotPassword(
              dispatch,
              "There's no account with this email. Please check the address, or register as a new user."
            );
            return;
          }
          let err = getErrorMsg(error);
          setErrorMsgInForgotPassword(dispatch, err.message);
        });
    } else {
      setErrorMsgInForgotPassword(dispatch, "Please enter your email address");
    }
  };
};

export const updateUserDetails = user => {
  return dispatch => {
    dispatch({ type: "UPDATE_USER_UID", payload: user.uid });
  };
};

export const resetLoginPage = () => {
  return dispatch => {
    dispatch({ type: "RESET_LOGIN_PAGE" });
  };
};

export const resetForgotPasswordPage = () => {
  return dispatch => {
    dispatch({ type: "RESET_FORGOT_PASSWORD_PAGE" });
  };
};

export const registerNewUserPage = () => {
  return dispatch => {
    dispatch({ type: "RESET_REGISTER_NEW_USER_PAGE" });
  };
};

export const signOut = () => {
  let auth = firebase.auth();
  return dispatch => {
    console.log("ran");
    auth
      .signOut()
      .then(function () {
        dispatch({ type: "LOGOUT_ATTEMPT" })
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

/**Helper Functions**/
// Once someone signs in on this device, they've already sorted out their password
// after the platform update, so the login page stops showing the "Returning user?" notice.
const UPDATE_NOTICE_KEY = "acp.signedInSinceUpdate";

export function hasSignedInSinceUpdate() {
  try {
    return window.localStorage.getItem(UPDATE_NOTICE_KEY) === "1";
  } catch (e) {
    return false;
  }
}

function markSignedInSinceUpdate() {
  try {
    window.localStorage.setItem(UPDATE_NOTICE_KEY, "1");
  } catch (e) {
    // Storage blocked (private mode etc.): the notice just keeps showing.
  }
}

const loginAttempSuccess = (dispatch, user, successCallBack) => {
  markSignedInSinceUpdate();
  dispatch({ type: "LOGIN_SUCCEEDED", payload: user });
  successCallBack();
};

const loginAttempFail = (dispatch, err, failureCallback, pos) => {
  dispatch({ type: "LOGIN_FAILED", payload: err.message });
  failureCallback();
};

// Shown for any failed sign-in with a known-format email. Accounts moved from the
// previous system have no password yet, so point people at "Forgot password?".
const BAD_CREDENTIALS_MSG =
  "Incorrect email or password. If you haven't signed in since the platform was updated, " +
  "please set a new password using “Forgot password?” below.";

function getErrorMsg(error) {
  let { code } = error;
  let raw = `${error.message || ""}`;
  switch (code) {
    case "auth/invalid-email":
      error.message = "Please enter a valid email address.";
      break;
    case "auth/user-not-found":
    case "auth/wrong-password":
    case "auth/invalid-credential":
      error.message = BAD_CREDENTIALS_MSG;
      break;
    case "auth/email-already-in-use":
      error.message = "This email is already registered. Please sign in, or use “Forgot password?” to set a new password.";
      break;
    case "auth/weak-password":
      error.message = "Please choose a password with at least 6 characters.";
      break;
    case "auth/too-many-requests":
      error.message = "Too many attempts. Please wait a few minutes, or reset your password using “Forgot password?”.";
      break;
    case "auth/network-request-failed":
      error.message = "Couldn't reach the server. Please check your internet connection and try again.";
      break;
    default:
      // With email-enumeration protection on, the server returns
      // INVALID_LOGIN_CREDENTIALS, which this SDK version reports as an internal error.
      if (raw.indexOf("INVALID_LOGIN_CREDENTIALS") !== -1 || raw.indexOf("INVALID_PASSWORD") !== -1) {
        error.message = BAD_CREDENTIALS_MSG;
      } else if (code === "auth/internal-error") {
        error.message = "Something went wrong. Please try again.";
      }
      break;
  }

  return error;
}

function setErrorMsgInForgotPassword(dispatch, msg) {
  // Stays on screen until the next attempt (it used to vanish after 3s).
  dispatch({ type: "SET_RESET_PASSWORD_ERROR_MSG", payload: msg });
}
/**End of Helper Functions**/
